import { searchFilter as SearchFilterIcon } from '@/assets/icons/icons';
import SearchInput from '@/components/SearchInput';

type SubFilterSearchProps = {
  searchQuery: string;
  isPaginated: boolean;
  setSearchQuery: (query: string) => void;
  setSearchDebounced: (query: string) => void;
  stopAll: (event: React.MouseEvent) => void;
};

const SubFilterSearch: React.FC<SubFilterSearchProps> = ({
  searchQuery,
  isPaginated,
  setSearchQuery,
  setSearchDebounced,
  stopAll,
}) => (
  <div
    style={{
      padding: '0 6px 8px',
      marginTop: 5,
    }}
    onMouseDown={stopAll}
    onClick={stopAll}
  >
    <SearchInput
      placeholder=''
      defaultValue={searchQuery}
      onChange={(val: string) => {
        setSearchQuery(val);
        if (isPaginated) setSearchDebounced(val);
      }}
      onClear={() => {
        setSearchQuery('');
        if (isPaginated) setSearchDebounced('');
      }}
      style={{ width: '100%' }}
      prefixIcon={<SearchFilterIcon width={12} height={12} />}
    />
  </div>
);

export default SubFilterSearch;
